import { Component, OnInit } from '@angular/core';
import { ConsignmentPlansConsignmentsService } from './consignment-plans-consignments.service';
import { TtScreenBlockService } from '../../../core/components/tt-screen-block/tt-screen-block.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-consignment-plans-consignments',
    templateUrl: './consignment-plans-consignments.component.html',
    styleUrls: ['./consignment-plans-consignments.component.css']
})
export class ConsignmentPlansConsignmentsComponent implements OnInit {
    private resizing: boolean = false;

    // This “model” object corresponds to your vm.model in the AngularJS code.
    model: any = {
        custact_no: 0,
        mconfig: {
            enabled: true,
            show: true,
            activate: (item: any) => {
                if (item === 'all') {
                    this.model.mconfig.records.forEach((data: any) => {
                        if (data && data.canActive === true) {
                            data.isActive = true;
                        }
                    });
                } else if (item && item.item_id) {
                    this.model.mconfig.records[item.item_id].isActive = false;
                } else if (item) {
                    for (let r = 0; r < this.model.mconfig.records.length; r++) {
                        if (
                            this.model.mconfig.records[r].item_name === item &&
                            this.model.mconfig.records[r].canActive === true
                        ) {
                            this.model.mconfig.records[r].isActive = true;
                            break;
                        }
                    }
                } else {
                    // do nothing, or some default logic
                }
            },
            deactivate: (item: any) => {
                if (item === 'all') {
                    this.model.mconfig.records.forEach((data: any) => {
                        if (data) {
                            if (data.item_name === 'resize' && data.isActive) {
                                this.consignmentPlansConsignmentsColumnResize();
                            }
                            if (data.canActive === true) {
                                data.isActive = false;
                            }
                        }
                    });
                } else if (item && item.item_id) {
                    this.model.mconfig.records[item.item_id].isActive = false;
                } else if (item) {
                    for (let r = 0; r < this.model.mconfig.records.length; r++) {
                        if (this.model.mconfig.records[r].item_name === item) {
                            this.model.mconfig.records[r].isActive = false;
                            break;
                        }
                    }
                } else {
                    // do nothing, or some default logic
                }
            },
            function: (item: any) => {
                if (item.canActive === true) {
                    item.isActive = !item.isActive;
                }

                // If item_name === 'settings', do something
                if (item.item_name === 'settings') {
                    this.stateService.go('consignmentplansdeliverysettings', {});
                }

                if (item.item_name === 'plus') {
                    this.stateService.go('consignmentplansorders', {
                        argtype: 'custact',
                        argvalue: this.model.custact_no
                    });
                }

                if (item.item_name === 'menu') {
                    this.stateService.go('consignmentplansdelivery', {});
                }

                // Resizing columns:
                if (item.item_name === 'resize') {
                    if (item.isActive) {
                        this.resizing = true;
                    } else {
                        this.consignmentPlansConsignmentsColumnResize();
                    }
                }
            },
            records: [
                {
                    item_id: '0',
                    item_name: 'option',
                    glyph: 'glyphicon-option-horizontal',
                    color: 'primary',
                    colorActive: 'warning',
                    canActive: true,
                    isActive: false,
                    enabled: true,
                    show: false
                },
                { item_id: '3', item_name: 'minus', glyph: 'glyphicon-minus', color: 'primary', show: false },
                {
                    item_id: '4',
                    item_name: 'menu',
                    glyph: 'glyphicon-align-justify',
                    color: 'primary',
                    enabled: true,
                    show: true
                },
                {
                    item_id: '5',
                    item_name: 'plus',
                    glyph: 'glyphicon-plus',
                    color: 'primary',
                    show: true
                },
                {
                    item_id: '6',
                    item_name: 'resize',
                    glyph: 'glyphicon-resize-horizontal',
                    color: 'primary',
                    colorActive: 'warning',
                    canActive: true,
                    isActive: false,
                    isIcon: false,
                    enabled: false,
                    show: true
                },
                {
                    item_id: '7',
                    item_name: 'edit',
                    glyph: 'fa-edit',
                    color: 'primary',
                    colorActive: 'warning',
                    canActive: true,
                    isActive: true,
                    isIcon: false,
                    enabled: false,
                    show: false
                },
                // { item_id: '8', item_name: 'settings', glyph: 'glyphicon-user', color: 'primary', enabled: true, show: true },
                { item_id: '10', item_name: 'uncheck', glyph: 'glyphicon-unchecked', color: 'primary', show: false },
                {
                    item_id: '99',
                    item_name: 'save',
                    glyph: 'glyphicon-save',
                    color: 'primary',
                    animate: null,
                    isIcon: true,
                    enabled: false,
                    show: true
                }
            ]
        },
        consignments: [],
        consignmentsRaw: [],
        settings_mode: 0,
        deliverymethod_no: 0,
        deliverymethods: [],
        loadingzone: '',
        loaded: false,
        stocklocation_keyno: 0,
        stocklocation_name: '',
        labour_no: '',
        labour_name: ''
    };

    constructor(
        private consignmentPlansConsignmentsService: ConsignmentPlansConsignmentsService,
        private ttScreenBlockService: TtScreenBlockService,
        private modalService: ModalService,
        private stateService: StateService,
    ) { }

    ngOnInit(): void {
        // Read the param from the route, if needed
        const params = this.stateService.getStateParams();

        this.model.custact_no = params['custact_no'];

        // 1) Load settings
        this.consignmentPlansConsignmentsService.loadSettings().then((data: any) => {
            this.model.loadingzone = data.loadingzone;
            this.model.deliverymethod_no = data.deliverymethod_no;

            if (parseInt(this.model.deliverymethod_no) > 0) {
                this.model.settings_mode = 1;
            }

            this.model.labour_no = data.labour_no;
            this.model.labour_name = data.labour_name;
            this.model.stocklocation_keyno = data.stocklocation_keyno;
            this.model.stocklocation_name = data.stocklocation_name;
        });

        // 2) Load delivery methods
        this.consignmentPlansConsignmentsService.loadDeliveryMethods().then((data: any) => {
            this.model.deliverymethods = [...data];
        });

        // 3) Load consignments
        this.loadConsignments();
    }

    saveSettings(): void {
        this.consignmentPlansConsignmentsService.remember('consignmentplansdelivery.deliverymethod_no', this.model.deliverymethod_no);
        this.consignmentPlansConsignmentsService.remember('consignmentplansdelivery.loadingzone', this.model.loadingzone);

        if (this.model.settings_mode === 1) {
            this.model.settings_mode = 0;
        } else {
            this.model.settings_mode = 1;
        }
    }

    cancelSettings(): void {
        if (this.model.settings_mode === 1) {
            this.model.settings_mode = 0;
        } else {
            this.model.settings_mode = 1;
        }
    }

    goToSelectLabour = () => {
        this.stateService?.go('consignmentplansdeliverylabour', {});
    }

    goToSelectLocation = () => {
        this.stateService?.go('consignmentplansdeliverylocation', {});
    }

    private loadConsignments(): void {
        this.ttScreenBlockService.start('message');
        this.ttScreenBlockService.setMessage('Laster informasjon');

        this.consignmentPlansConsignmentsService
            .loadConsignments({ custact_no: this.model.custact_no })
            .then((data: any[]) => {
                const smallDataLoad: any[] = [];

                for (let i = 0; i < data.length; i++) {
                    // Replace illegal chars in item_id:
                    data[i].item_id = this.illegalCharRegExp(data[i].item_id);

                    smallDataLoad.push(data[i]);
                }

                this.model.consignments = [...smallDataLoad];
                this.model.consignmentsRaw = [...smallDataLoad];
                this.model.loaded = true;

                this.ttScreenBlockService.stop();
            });
    }

    private illegalCharRegExp(str: string): string {
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '-');
    }

    consignmentPlansConsignmentsColumnResize(): void {
        // Animate "save" icon
        for (let m = 0; m < this.model.mconfig.records.length; m++) {
            const record = this.model.mconfig.records[m];
            if (record && record.item_id === '99') {
                record.animate = true;
                break;
            }
        }

        const updateList: any[] = [];

        // If the first consignment has item_secondary, gather data for update
        if (
            this.model.consignments[0] &&
            this.model.consignments[0].item_secondary
        ) {
            for (let r = 0; r < this.model.consignments[0].item_secondary.length; r++) {
                if (r === 0) {
                    updateList.push({
                        item_id: r,
                        item_col_width: this.model.consignments[0].item_col_width
                    });
                }
                if (this.model.consignments[0].item_secondary[r]) {
                    updateList.push({
                        item_id: r + 1,
                        item_col_width: this.model.consignments[0].item_secondary[r].item_col_width
                    });
                }
            }
        }

        const updateParms = {
            view_id: 'consignmentplansconsignments.list',
            records: updateList
        };

        // Call service to persist
        this.consignmentPlansConsignmentsService.updateColumnResize(updateParms).then((data: any) => {
            if (data[0].errorcode !== '0') {
                this.modalService.show({
                    type: 'warning',
                    title: 'Varsel',
                    message: data[0].errormessage,
                    buttons: [
                        {
                            label: 'OK',
                            cssClass: 'btn-warning',
                            action: (dialogItself: any) => {
                                dialogItself.close();
                            }
                        }
                    ]
                });
            } else {
                // Stop animation
                for (let m = 0; m < this.model.mconfig.records.length; m++) {
                    const record = this.model.mconfig.records[m];
                    if (record && record.item_id === '99') {
                        record.animate = false;
                        // Clear the animation flag after 2s
                        setTimeout(() => {
                            record.animate = null;
                        }, 2000);
                        break;
                    }
                }
            }

            this.resizing = false;
        });
    }
}
